module.exports = __webpack_public_path__ + "img/ic_placeholder.8a14c24f.svg";